import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import * as classNames from 'classnames';
import { NavItem } from '../../shared';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spinner } from '../Controls/Spinner';
import { Login } from '../DiscussionBoard/Login';
import PeopleContainer from './People/People';
import PersonContainer from './People/Person';
import NewsContainer from './News/News';
import NewsItemContainer from './News/NewsItem';
import ResearchContainer from './Research/Research';
import ResearchItemContainer from './Research/ResearchItem';
import PublicationsContainer from './Publications/Publications';
import PublicationContainer from './Publications/Publication';
import Notification from '../Controls/Notification';
import ContentSettingsContainer from './Content/ContentSettings';

import * as LoginActionCreators from "../../actions/login.actions";
import * as MembersActionCreators from "../../actions/members.actions";

class AdministrationLayout extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            tab: "people"
        };
        this.props.validate();
        this.onLogout = this.onLogout.bind(this);
        this.onSelectTab = this.onSelectTab.bind(this);
    }

    tabCss(tab) {
        if (tab == this.state.tab) {
            return "nav-link active";
        }
        return "nav-link";
    }

    onLogout() {
        this.props.logout();
    }

    onSelectTab(tab: string) {
        this.setState({ tab });
    }

    render() {
        let content;
        let tabs;
        const { currentUser, forum, login, ...props } = this.props;

        if (this.props.isLoading) {
            content = (
                <Spinner isOpen={this.props.isLoading} />
            );
        } else if (!this.props.currentUser || !this.props.currentUser.isAdmin) {
            content = (
                <Login login={login} {...this.props}></Login>
            );
        } else {
            tabs = (
                <div className="row lightgrey-bg mb-4">
                    <ul className="discussion-board nav nav-tabs lightgrey-bg col-12">
                        <li className="nav-item">
                            <a className={this.tabCss("people")} onClick={() => this.onSelectTab("people")} href="#">People</a>
                        </li>
                        <li className="nav-item">
                            <a className={this.tabCss("news")} onClick={() => this.onSelectTab("news")} href="#">News</a>
                        </li>
                        <li className="nav-item">
                            <a className={this.tabCss("project")} onClick={() => this.onSelectTab("project")} href="#">Projects</a>
                        </li>
                        <li className="nav-item">
                            <a className={this.tabCss("publications")} onClick={() => this.onSelectTab("publications")} href="#">Publications</a>
                        </li>
                        <li className="nav-item">
                            <a className={this.tabCss("content")} onClick={() => this.onSelectTab("content")} href="#">Content</a>
                        </li>
                        <li className="nav-item">
                            <a
                                onClick={() => this.onLogout()}
                                className={this.tabCss("logout")} >Logout</a>
                        </li>
                    </ul>
                </div>
            );
            if (this.state.tab == "people") {
                if (this.props.personId != -1) {
                    content = (
                        <PersonContainer />
                    );
                }
                else {
                    content = (
                        <PeopleContainer />
                    );
                }

            } else if (this.state.tab == "news") {
                if (this.props.newsId != -1) {
                    content = (
                        <NewsItemContainer />
                    );
                }
                else {
                    content = (
                        <NewsContainer />
                    );
                }
            } else if (this.state.tab == "project") {
                if (this.props.researchId != -1) {
                    content = (
                        <ResearchItemContainer />
                    );
                }
                else {
                    content = (
                        <ResearchContainer />
                    );
                }
            } else if (this.state.tab == "publications") {
                if (this.props.publicationId != -1) {
                    content = (
                        <PublicationContainer />
                    );
                }
                else {
                    content = (
                        <PublicationsContainer />
                    );
                }
            } else if (this.state.tab == "content") {
                content = (
                    <ContentSettingsContainer />
                );
            }
        }

        return (
            <div id="SectionContainer">
                <section className="content">
                    <div className="container container-admin">
                        <div className="row">
                            <div className={classNames("col-12", "base1-bg")} >
                                <h1 className={classNames("text-center")}>Admin Area</h1>
                            </div>
                        </div>
                        {tabs}
                        <Notification />
                        {content}

                    </div>
                </section>
            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        currentUser: state.discussionBoard.currentUser,
        isLoading: state.discussionBoard.forumLoading,
        personId: state.people.person.id,
        newsId: state.news.newsItem.id,
        researchId: state.research.researchItem.id,
        publicationId: state.publications.publication.id
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            login: LoginActionCreators.loginRequest,
            resetPassword: LoginActionCreators.resetPasswordRequest,
            resetPasswordUpdate: LoginActionCreators.resetPasswordUpdateRequest,
            validate: LoginActionCreators.loginValidate,
            getCurrentUser: LoginActionCreators.getCurrentUserRequest,
            logout: LoginActionCreators.logoutRequest,

            getMember: MembersActionCreators.getMemberRequest,
            saveUser: MembersActionCreators.saveMemberRequest,
            editUser: MembersActionCreators.editUser,
            clearUser: MembersActionCreators.clearUser,
            searchUsers: MembersActionCreators.searchMemberRequest,
            updateNotification: MembersActionCreators.setNotificationRequest,
            updateEmailFrequency: MembersActionCreators.setUpdateFrequencyRequest,
        },
        dispatch
    );
};


const AdministrationContainer = connect(mapStateToProps, mapDispatchToProps)(
    AdministrationLayout
);

export default AdministrationContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/AdministrationContainer.tsx